// His `isDesk`: a PC — a fine pointer and not a phone or tablet. A PC gets the live webcam dialog and
// no "📱 Photo station" button; a tablet the opposite.
export const isDesk = () => {
  try {
    return matchMedia("(pointer:fine)").matches && !/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
  } catch {
    return false;
  }
};

// His `CAMOK`: the browser can open a camera at all.
export const camOk = () => typeof navigator !== "undefined" && !!navigator.mediaDevices?.getUserMedia;
